module.exports = __webpack_public_path__ + "static/media/signRequestFail.d20b43d1.svg";